export default __webpack_public_path__ + "static/media/star.4201e2f5.svg";